"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OTHER = exports.DIVORCE = exports.PATERNITY = exports.CHILD_CUSTODY = exports.CHILD_SUPPORT = exports.SMALL_CLAIMS = exports.COLLECTION_LAWSUIT = exports.PERSONAL_INJURY = void 0; // Lawsuits

var PERSONAL_INJURY = 'personalInjury';
exports.PERSONAL_INJURY = PERSONAL_INJURY;
var COLLECTION_LAWSUIT = 'collectionLawsuit';
exports.COLLECTION_LAWSUIT = COLLECTION_LAWSUIT;
var SMALL_CLAIMS = 'smallClaims';
exports.SMALL_CLAIMS = SMALL_CLAIMS;
var CHILD_SUPPORT = 'childSupport';
exports.CHILD_SUPPORT = CHILD_SUPPORT;
var CHILD_CUSTODY = 'childCustody';
exports.CHILD_CUSTODY = CHILD_CUSTODY;
var PATERNITY = 'paternity';
exports.PATERNITY = PATERNITY;
var DIVORCE = 'divorce'; // ?

exports.DIVORCE = DIVORCE;
var OTHER = 'other';
exports.OTHER = OTHER;